// @ts-nocheck

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { addPublicationQuery, fetchPublicationByIdQuery, fetchPublicationTableQuery, removePublicationQuery, updatePublicationQuery } from "../../api/publicationApi";

// Async thunks for Our service operations

export const getPublication = createAsyncThunk(
  "publication/getPublication",
  async ({ page, limit, lan }: { page: number; limit: number; lan: string }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchPublicationTableQuery(page, limit, lan);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getPublicationById = createAsyncThunk(
  "publication/getPublicationById",
  async ({ id, lan }: { id: string, lan: string }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchPublicationByIdQuery(id, lan);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const createPublication = createAsyncThunk(
  "publication/createPublication",
  async (newPublication: { name: string; description: string; icon: string; }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await addPublicationQuery(newPublication);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const editPublication = createAsyncThunk(
  "publication/editPublication",
  async ({ id, updatedPublication, lan }: { id: string; updatedPublication: { name: string; description: string; icon?: string }; lan: string }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await updatePublicationQuery(id, updatedPublication, lan);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletePublication = createAsyncThunk(
  "publication/deletePublication",
  async (id: string, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await removePublicationQuery(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Other Service Slice

const publicationSlice = createSlice({
  name: "publication",
  initialState: {
    publications: [] as any[],
    publication: null as any | null,
    status: null as boolean | null,
    msg: "",
    error: null as string | null,
  },
  reducers: {
    resetStatus(state) {
      state.status = null;
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Get all Other services
      .addCase(getPublication.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.status = true;
        state.publications = action.payload;
      })
      .addCase(getPublication.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })

      // Get Other service by ID
      .addCase(getPublicationById.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = true;
        state.publication = action.payload;
      })
      .addCase(getPublicationById.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })

      // Create Other service
      .addCase(createPublication.fulfilled, (state, action: PayloadAction<any>) => {
        if (Array.isArray(action.payload)) {
          state.publications.push(action.payload);
          state.status = true;
          state.msg = "Other service created successfully.";
        } else {
           // // // console.log('Other service not an array');
        }
      })

      // Edit Other service
      .addCase(editPublication.fulfilled, (state, action: PayloadAction<any>) => {
        const { id, data } = action.payload;
        if (Array.isArray(state.publications)) {
          const index = state.publications.findIndex((service) => service.id === id);
          if (index !== -1) {
            state.publications[index] = data;
          }
          state.status = true;
          state.msg = "Other service updated successfully.";
        } else {
           // // // console.log('Other service not an array');
        }
      })

      // Delete Other service
      .addCase(deletePublication.fulfilled, (state, action: PayloadAction<string>) => {
        if (Array.isArray(state.publications)) {
          state.publications = state.publications.filter((service) => service.id !== action.payload);
          state.status = true;
          state.msg = "Other service deleted successfully.";
        } else {
           // // // console.log('Other service not an array');
        }
      });
  },
});

export const { resetStatus } = publicationSlice.actions;
export default publicationSlice.reducer;
